import { Link } from 'react-router-dom';
import { ArrowUpRight, Instagram, Linkedin } from 'lucide-react';
import { DubaiClock } from './DubaiClock';
import { CONTACT, FOUNDERS, SOCIALS } from '@/data/content';

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-cream rounded-t-[2.5rem] mt-28 relative overflow-hidden">
    <div className="px-6 sm:px-12 pt-20 pb-8">
      <div className="grid lg:grid-cols-2 gap-14 items-end border-b border-cream/15 pb-16">
        <div>
          <p className="font-script text-butter text-4xl sm:text-5xl mb-3 -rotate-2 inline-block">smooth, rich, confident.</p>
          <h2 className="font-slab font-black text-4xl sm:text-5xl leading-[1.04] tracking-tight">
            Let’s tell your story<br />the buttery way.
          </h2>
          <Link
            to="/contact"
            data-testid="footer-cta-contact"
            className="mt-9 inline-flex group items-center gap-2 bg-butter text-ink font-slab font-bold px-8 py-4 rounded-full border border-butter hover:bg-transparent hover:text-butter transition-colors duration-300"
          >
            Start a Project
            <ArrowUpRight size={18} className="group-hover:rotate-45 transition-transform duration-300" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 gap-10 text-sm">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-cream/45 mb-4">Get in touch</p>
            <ul className="space-y-2.5 text-cream/80">
              <li><a data-testid="footer-email-link" href={`mailto:${CONTACT.email}`} className="hover:text-butter transition-colors">{CONTACT.email}</a></li>
              {FOUNDERS.map((f) => (
                <li key={f.phone}>
                  <a href={`tel:${f.phone.replace(/\s/g, '')}`} className="hover:text-butter transition-colors">{f.phone}</a>
                  <span className="text-cream/40"> — {f.name.split(' ')[0]}</span>
                </li>
              ))}
              <li className="text-cream/50">{CONTACT.city}</li>
            </ul>
          </div>
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-cream/45 mb-4">Explore</p>
            <ul className="space-y-2.5 text-cream/80">
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-butter transition-colors">About</Link></li>
              <li><Link data-testid="footer-link-services" to="/services" className="hover:text-butter transition-colors">Services</Link></li>
              <li><Link data-testid="footer-link-work" to="/work" className="hover:text-butter transition-colors">Work</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-butter transition-colors">Contact</Link></li>
            </ul>
            <div className="flex gap-3 mt-6">
              <a data-testid="footer-social-instagram" href={SOCIALS.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="w-10 h-10 rounded-full border border-cream/25 flex items-center justify-center hover:bg-butter hover:text-ink hover:border-butter transition-colors"><Instagram size={16} /></a>
              <a data-testid="footer-social-linkedin" href={SOCIALS.linkedin} target="_blank" rel="noreferrer" aria-label="LinkedIn" className="w-10 h-10 rounded-full border border-cream/25 flex items-center justify-center hover:bg-butter hover:text-ink hover:border-butter transition-colors"><Linkedin size={16} /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="py-12 flex justify-center">
        <img
          src="/assets/logo-cream.png"
          alt="Butter Media"
          data-testid="footer-logo"
          className="w-full max-w-3xl opacity-80 hover:opacity-100 transition-opacity duration-700"
        />
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-cream/15 pt-6 text-xs text-cream/45">
        <span>© {new Date().getFullYear()} Butter Media — Dubai’s 360° Content Studio</span>
        <DubaiClock dark />
      </div>
    </div>
  </footer>
);
